<template>
  <div class="min-h-screen">
    <BaseContainer>
      <main class="max-w-2xl mx-auto py-16 md:py-24">
        <h1 class="h2 mb-4">
          {{ t('checkout.basket_timeout_heading') }}
        </h1>
        <p class="text-text mb-10">
          {{ t('checkout.basket_timeout_description') }}
        </p>
        <div class="flex flex-col sm:flex-row gap-4">
          <BaseButton color="primary" @click="startOver">
            {{ t('checkout.basket_timeout_start_over') }}
          </BaseButton>
          <BaseButton color="outline" @click="closeDrawer">
            {{ t('common.close') }}
          </BaseButton>
        </div>
      </main>
    </BaseContainer>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import BaseContainer from '@/components/ui/BaseContainer.vue';
  import { useCheckoutStore } from '@/stores/checkoutStore';
  import { EMBED_RESTART_DRAWER } from '@/utils/embedMessageTypes';
  import { closeEmbedDrawer } from '@/utils/embedNavigation';
  import { isEmbed } from '@/utils/isEmbed';

  const { t } = useI18n();
  const router = useRouter();
  const checkoutStore = useCheckoutStore();

  const checkoutId = computed(() => checkoutStore.getCheckoutID());

  function isValidCheckoutId(id: number | string | undefined): id is number | string {
    return (typeof id === 'number' && id > 0) ||
      (typeof id === 'string' && (/^\d+$/.test(id) || /^[0-9a-f]{96}$/.test(id)));
  }

  function closeDrawer() {
    if (closeEmbedDrawer()) return;
    router.push('/');
  }

  function startOver() {
    if (isValidCheckoutId(checkoutId.value)) {
      router.push({ name: 'checkout-tickets', params: { id: checkoutId.value } });
      return;
    }
    if (isEmbed()) {
      window.parent.postMessage({ type: EMBED_RESTART_DRAWER }, '*');
      return;
    }
    router.push('/');
  }

  onMounted(() => {
    localStorage.removeItem('showEmptiedCartToast');
    localStorage.removeItem('showUnpaidOrderExpiredToast');
  });
</script>
